import {
  CounterBag,
  Div,
  IconBag,
  IconMenu,
  IconSearch,
  Input,
} from "../../Styles/Styled";
import { FaBars } from "react-icons/fa";
import { useContext, useEffect, useState } from "react";
import { GestorContext } from "../../store/GestorStore";
import RightAside from "../RightAside";
import LeftAside from "../LeftAside";
import ListGroups from "../ListGrups";
import { Colors } from "../../config";

interface IHeader {
  fixed: boolean;
  dados: string[];
  gruposnv2: string[];
}
export default function Header(props: IHeader) {
  const [count, setCount] = useState(0);
  const [openRightAside, setOpenRightAside] = useState(false);
  const [openLeftAside, setOpenLeftAside] = useState(false);
  const Gestor = useContext(GestorContext);
  const height = window.innerHeight;
  const heightCabecalho = height * 0.25;
  const heightLinhaTitulo = heightCabecalho * 0.45;
  const heightLinhaEndereco = heightCabecalho * 0.4;
  const heightInput = heightLinhaTitulo * 0.6;
  const width = window.innerWidth;

  useEffect(() => {
    if (Gestor) {
      setCount(Gestor.state.carrinho.length);
    }
  }, [Gestor]);


  const handleOpenAside = (type: number) => {
    console.log(`type: ${type}`);
    if (type === 0) {
      // 0 is left aside, 1 is right aside
      setOpenLeftAside(true);
      setOpenRightAside(false);
    } else {
      setOpenLeftAside(false);
      setOpenRightAside(true);
    }
  };

  return (
    <>
      <RightAside
        open={openRightAside}
        onCloseAside={() => setOpenRightAside(false)}
      />
      <LeftAside
        open={openLeftAside}
        onCloseAside={() => setOpenLeftAside(false)}
      />
      {props.fixed && (
        <Div Height={`${heightCabecalho}px`} Width={"100vw"}>
          PESO
        </Div>
      )}
      <Div
        id="Header"
        Position={props.fixed ? "fixed" : "relative"}
        className={props.fixed ? "animation-header" : ""}
        style={
          props.fixed
            ? {
                top: 0,
                zIndex: 14,
                minHeight: "auto",
                height: "auto",
                paddingBottom: 5,
                border: `1px solid ${Colors.headerBorderColors}`,
                backgroundColor: Colors.header,
              }
            : {
                border: `1px solid ${Colors.headerBorderColors}`,
                backgroundColor: Colors.header,
              }
        }
        borderRadius={
          !props.fixed
            ? { bottom: { left: "10px", right: "10px" } }
            : { bottom: { left: "10px", right: "10px" } }
        }
        background="#fcfcfc"
        Height={`${heightCabecalho}px`}
        Padding={{
          top: "10px",
        }}
        Items="center"
        Width={"99%"}
        Content="space-evenly"
      >
        <Div Height={`${heightLinhaTitulo}px`} row Content="space-around">
          <Div
            Width={`${width * 0.4}px`}
            Height={heightLinhaTitulo + "px"}
            Content="center"
            Items="center"
            onClick={() => handleOpenAside(1)}
            Touch={true}
          >
            <IconMenu size={25} color={Colors.icon} />
          </Div>

          <Div
            Content="center"
            Items="center"
            Width={`${heightLinhaTitulo * 0.9}px`}
            Height={`${heightLinhaTitulo * 0.9}px`}
            style={{ borderRadius: "50%", backgroundColor: Colors.headerCircleColor }}
          >
            <img
              src="./logo.png"
              style={{
                width: heightLinhaTitulo * 0.9,
                borderRadius: "50%",
                objectFit: "contain",
                height: heightLinhaTitulo * 0.9,
              }}
            />
          </Div>
          <Div
            Width={`${width * 0.4}px`}
            Height={heightLinhaTitulo + "px"}
            Content="center"
            Touch={true}
            onClick={() => handleOpenAside(1)}
            Items="center"
          >
            <CounterBag Text={`${count}`} TextColor="#17100e" />

            <IconBag size={25} color={Colors.icon} />
          </Div>
        </Div>
        {!props.fixed && (
          <Div
            row
            Items="center"
            Height={"auto"}
            Content="center"
            borderRadius={{ bottom: { left: "30px", right: "30px" } }}
          >
            <Div
              Height={heightInput + "px"}
              Width={"90%"}
              TextColor="#fcfcfc"
              row
              style={{
                border: `1px solid ${Colors.headerBorderColors}`,
                background: Colors.inputHeaderBackgroundColor,
              }}
              background="##fcfcfc"
              borderRadius={{
                top: { left: "15px", right: "15px" },
                bottom: { left: "15px", right: "15px" },
              }}
              Items="center"
              Padding={{
                left: "2px",
              }}
            >
              <IconSearch size={20} color={Colors.header} />

              <Input
                Height={heightInput + "px"}
                Width={`${width}`}
                TextColor={Colors.inputHeaderTextColor}
                borderRadius={{
                  top: { left: "15px", right: "15px" },
                  bottom: { left: "15px", right: "15px" },
                }}
                Placeholder={{
                  text: "Pesquisar Produto",
                  color: Colors.inputHeaderPlaceHolderColor,
                }}
                Padding={{
                  left: "5px",
                  right: "5px",
                }}
              />
            </Div>
          </Div>
        )}
        {props.fixed && <ListGroups fixed={true} groupsnv2={props.gruposnv2} items={props.dados} />}
      </Div>
    </>
  );
}
